function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function (_typeof2) { function _typeof(_x) { return _typeof2.apply(this, arguments); } _typeof.toString = function () { return _typeof2.toString(); }; return _typeof; }(function (obj) { return typeof obj; }); } else { _typeof = function (_typeof3) { function _typeof(_x2) { return _typeof3.apply(this, arguments); } _typeof.toString = function () { return _typeof3.toString(); }; return _typeof; }(function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }); } return _typeof(obj); }

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import { messages, filterClearButton } from '../messages';
import { provideLocalizationService } from '@progress/kendo-vue-intl';
import { operators, operatorMap, cellBoolDropdownChange, cellInputChange, cellOperatorChange } from '../filterCommon';
import { VueComponent, templateRendering } from '@progress/kendo-vue-common';
import Component from 'vue-class-component';
import { Grid } from '../main';
export { operators };
/**
 * @hidden
 */

var GridFilterCell =
/** @class */
function (_super) {
  __extends(GridFilterCell, _super);

  function GridFilterCell() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * @hidden
   */
  // @ts-ignore


  GridFilterCell.prototype.render = function (h) {
    var _this = this;

    var localizationService = provideLocalizationService(this);
    var dataItems = operatorMap(operators[this.$props.filterType], localizationService);
    var selectedOperator = dataItems.find(function (item) {
      return item.operator === _this.$props.operator;
    }) || null;

    var optionMapper = function optionMapper(items, selected) {
      return items.map(function (item) {
        if (selected && item.operator === selected.operator) {
          return h("option", {
            domProps: {
              "value": item.operator
            },
            attrs: {
              selected: true
            }
          }, [item.text]);
        } else {
          return h("option", {
            domProps: {
              "value": item.operator
            }
          }, [item.text]);
        }
      });
    };

    var operatorOptions = optionMapper(dataItems, selectedOperator);

    var filterComponent = function filterComponent(filterType, value) {
      switch (filterType) {
        case 'numeric':
          return h("input", {
            attrs: {
              type: "number"
            },
            "class": "k-textbox",
            domProps: {
              "value": value
            },
            on: {
              "input": function input(e) {
                _this.inputChange(parseFloat(e.target.value), e);
              }
            }
          });

        case 'date':
          var newDateValue = new Date(value);
          return h("input", {
            attrs: {
              type: "date"
            },
            "class": "k-textbox",
            domProps: {
              "value": _this.formatDate(newDateValue)
            },
            on: {
              "change": function change(e) {
                if (!e.target.value) {
                  _this.clear(e);
                } else {
                  var currentDate = new Date(e.target.value);

                  _this.inputChange(new Date(currentDate.getTime() + currentDate.getTimezoneOffset() * 60000), e);
                }
              }
            }
          });

        case 'boolean':
          var data = operatorMap(operators.boolean, localizationService);
          var booleanOptions = optionMapper(data, value);
          return h("select", {
            on: {
              "input": function input(e) {
                _this.boolDropdownChange(e.target.value, e);
              }
            },
            "class": "k-textbox"
          }, [booleanOptions]);

        default:
          return h("input", {
            "class": "k-textbox",
            domProps: {
              "value": value || ''
            },
            on: {
              "input": function input(e) {
                _this.inputChange(e.target.value, e);
              }
            }
          });
      }
    };

    var defaultRendering = h("div", {
      "class": "k-filtercell"
    }, [h("div", {
      "class": "k-filtercell-wrapper"
    }, [filterComponent(this.$props.filterType, this.$props.value), h("div", {
      "class": "k-filtercell-operator"
    }, [this.$props.filterType !== 'boolean' && h("select", {
      "class": "k-textbox",
      style: "width: 30px;",
      on: {
        "change": function change(e) {
          _this.operatorChange(e.target.value, e);
        }
      }
    }, [operatorOptions]), h("button", {
      "class":
      /* button is always visible if there is either value or operator */
      !(this.$props.value === null || this.$props.value === '') || this.$props.operator ? 'k-button k-button-icon k-clear-button-visible' : 'k-button k-button-icon',
      attrs: {
        title: localizationService.toLanguageString(filterClearButton, messages[filterClearButton]),
        type: "button"
      },
      on: {
        "click": this.clear
      }
    }, [h("span", {
      "class": "k-icon k-i-filter-clear"
    })])])])]);
    var gridListeners = this.$props.grid ? this.$props.grid.$listeners : null;
    var cellRenderFunction = templateRendering.call(this.$props.grid, this.$props.render, gridListeners);

    if (cellRenderFunction) {
      var events = {
        change: this.triggerChange,
        gridListeners: gridListeners
      };

      if (cellRenderFunction.type === 'slot') {
        return cellRenderFunction.render({
          props: this.$props,
          listeners: events,
          methods: events
        });
      } else if (cellRenderFunction.type === 'renderFunction') {
        return cellRenderFunction.render(h, defaultRendering, this.$props, events);
      } else {
        return h(cellRenderFunction.render, {
          props: this.$props,
          on: events
        });
      }
    } else {
      return defaultRendering;
    }
  };

  GridFilterCell.prototype.inputChange = function (value, e) {
    var filter = cellInputChange(value, e, this.$props);
    this.triggerChange(filter);
  };

  GridFilterCell.prototype.operatorChange = function (operatorValue, e) {
    var filter = cellOperatorChange(operatorValue, e, this.$props.value);
    this.triggerChange(filter);
  };

  GridFilterCell.prototype.boolDropdownChange = function (value, e) {
    value = value === '' ? '' : this.getBoolValue(value);
    var filter = cellBoolDropdownChange(value, e);
    this.triggerChange(filter);
  };

  GridFilterCell.prototype.formatDate = function (date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear().toString().padStart(4, '0');

    if (month.length < 2) {
      month = '0' + month;
    }

    if (day.length < 2) {
      day = '0' + day;
    }

    return [year, month, day].join('-');
  };

  GridFilterCell.prototype.getBoolValue = function (value) {
    return value === 'true' ? true : false;
  };

  GridFilterCell.prototype.clear = function (e) {
    e.preventDefault();
    this.triggerChange({
      value: '',
      operator: '',
      event: e
    });
  };

  GridFilterCell.prototype.triggerChange = function (filter) {
    filter.field = this.$props.field;
    this.$emit('change', filter);
  };

  GridFilterCell = __decorate([Component({
    props: {
      grid: Grid,
      field: String,
      filterType: String,
      value: [String, Number, Boolean, Date],
      operator: [String, Function],
      onChange: Function,
      render: [String, Function, Object]
    },
    inject: {
      kendoLocalizationService: {
        default: null
      },
      kendoIntlService: {
        default: null
      }
    }
  })], GridFilterCell);
  return GridFilterCell;
}(VueComponent);

export { GridFilterCell };